if (!customElements.get('square-feet-calculator')) {
  class SquareFeetCalculator extends HTMLElement {
    constructor() {
      super();
      // Default values
      this.minimum = 1;          // Minimum recommended boxes
      this.recommended = 1;      // Calculated boxes based on input
      this.measurement = 0;      // User input measurement (sq ft)
      this.sqFtInBox = 0;        // Sq ft coverage per box (from dataset)
      this.pricePerBox = 0;      // Price per box (from dataset)
      this.totalSqFeet = 0;      // Final calculated total sq ft
    }

    connectedCallback() {
      // Cache all DOM elements once for efficiency
      const selectors = {
        measurement: this.querySelector('.box-input .measurement'),      // User input field
        totalBoxes: this.querySelector('.calculator .total-boxes'),      // Output: recommended boxes
        totalSqFeet: this.querySelector('.calculator .total-sq-feet'),   // Output: total sq ft
        quantityInput: document.querySelector('input.quantity__input'),  // Shopify quantity input
        calculator: this.querySelector('.calculator'),                   // Calculator container
      };

      // Get dataset values once when component loads
      this.sqFtInBox = parseFloat(this.dataset.squareFeetPerBox) || 0;
      this.pricePerBox = parseFloat(this.dataset.pricePerBox) || 0;

      // Listen for user input on the measurement field
      selectors.measurement.addEventListener('input', () => {
        // Show calculator output area when user types
        selectors.calculator.classList.add('active');

        // Get and parse the user's input; fallback to 0 if empty or invalid
        const inputVal = parseFloat(selectors.measurement.value) || 0;

        // Calculate recommended boxes based on input measurement
        if (inputVal > this.minimum) {
          this.recommended = Math.ceil(inputVal / this.sqFtInBox);
          selectors.quantityInput.value = this.recommended;  // Update Shopify quantity input
        } else {
          this.recommended = this.minimum;
          selectors.quantityInput.value = this.minimum;
        }

        // Calculate total square footage covered
        this.totalSqFeet = this.recommended * this.sqFtInBox;

        // Update calculator display with results
        selectors.totalBoxes.innerText = `Boxes: ${this.recommended}`;
        selectors.totalSqFeet.innerHTML = `Sq. Ft.: ${this.totalSqFeet.toFixed(2)}`;
      });
    }
  }

  // Register the custom element if not already defined
  customElements.define('square-feet-calculator', SquareFeetCalculator);
}